import * as yup from 'yup';

export const FIELD_ORGANIZATION = 'organization';
export const FIELD_DIRECTION = 'direction';
export const FIELD_REGION = 'region';
export const FIELD_DISTRICT = 'district';
export const FIELD_ADDRESS = 'address';
export const FIELD_ADDRESS_RU = 'address.ru';
export const FIELD_ADDRESS_UZ = 'address.uz';
export const FIELD_ADDRESS_OZ = 'address.oz';
export const FIELD_PHONE = 'phone';
export const FIELD_EMAIL = 'email';
export const FIELD_PLACE_COUNT = 'placeCount';
export const FIELD_NAME = 'name';
export const FIELD_NAME_RU = 'name.ru';
export const FIELD_NAME_UZ = 'name.uz';
export const FIELD_NAME_OZ = 'name.oz';

export const LocationsEditValidationForm = yup.object().shape({
  [FIELD_NAME_RU]: yup.string().trim(),
  [FIELD_NAME_UZ]: yup.string().trim(),
  [FIELD_NAME_OZ]: yup.string().trim(),
  [FIELD_ORGANIZATION]: yup.string().required('error.required').trim(),
  [FIELD_DIRECTION]: yup.string().required('error.required').trim(),
  [FIELD_REGION]: yup.string().required('error.required').trim(),
  [FIELD_DISTRICT]: yup.string().required('error.required').trim(),
  [FIELD_ADDRESS_RU]: yup.string().trim(),
  [FIELD_ADDRESS_UZ]: yup.string().trim(),
  [FIELD_ADDRESS_OZ]: yup.string().trim(),
  [FIELD_PHONE]: yup
    .string()
    .transform((value) => value.replace(/\s/g, ''))
    .length(13, 'error.phoneFormat')
    .required('error.required'),
  [FIELD_EMAIL]: yup.string().email('error.email').required('error.required').trim(),
  [FIELD_PLACE_COUNT]: yup.string().required('error.required').trim(),
});
